/* eslint import/prefer-default-export: 0 */
import axios from '../utils/api'

import CONFIG from '../config'
import { LIST_ROLES_REQUEST, LIST_ROLES_RESPONSE } from '../constants'

export function listRoles() {
  return (dispatch) => {
    dispatch({ type: LIST_ROLES_REQUEST })

    axios.get(`${CONFIG.apiBase}/roles`).then((response) => {
      dispatch({
        type: LIST_ROLES_RESPONSE,
        roles: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}
